export default `
  @page {
    size: A4;
    size: portrait;
    margin: 20mm;
  }
  * {
    box-sizing: border-box;
  }
  body {
    margin: 0;
    padding: 0;
    font-size: 12pt;
  }
`